import React, { useEffect, useState } from 'react';
import PageHeading from '../../components/PageHeading/PageHeading';
import SearchInput from '../../components/SearchInput/SearchInput';
import Button from '../../components/Button/Button';
import InputForm from '../../components/InputForm/InputForm';
import MuiTable from '../../components/MuiTable/MuiTable';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import instance from '../../service/axiosInstane';
import { StateProps } from '../../redux/reducer';
import { Role, SortOrderType } from '../../config/enum';
import { flashBarTheme } from '../../config/flashBar';
import qs from 'qs';
import { totalPages } from '../../config/helpers';
import Input from '../../components/Input/Input';
import { errorMessage } from '../../config/errorsMsg';
import Dropdown from '../../components/Dropdown/Dropdown';
import MultipleFilter from '../../components/MultipleFilter/MultipleFilter';
import { Column } from '../../components/MuiTable/ViewData';
import Filter from '../../components/Filter/Filter';
import { successMessage } from '../../config/keyword';

type AddCategoryProps = {
  name: string;
  categoryLabelId: string;
  organizationId: string;
  lable: string;
};
type RequestProps = {
  page: number;
  pageSize: number;
  searchText: string;
  organizationFilter: string[];
  LabelFilter: string[];
  IsActiveFilter: boolean;
  sortBy: string;
  sortOrder: string;
};
type CategoryResponceProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results?: ResultProps[];
};

type ResultProps = {
  name: string;
  organizationId: string;
  id: string;
  categoryLabelId: string;
  categoryLabelName: string;
  keywordCount: string;
};

type FitleObject = {
  type: string;
  selectedMenu: string[];
};

const columns: Column[] = [
  { id: 'name', label: 'Category', minWidth: 200, align: 'left' },
  { id: 'categoryLabelName', label: 'Label', minWidth: 70, align: 'left' },
  { id: 'keywordCount', label: 'Total Keywords', minWidth: 70, align: 'center' },
  { id: 'action', label: 'Action', minWidth: 0, align: 'right' },
];

const Categories = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [category, setCategory] = useState<ResultProps[]>([]);
  const [formError, setFormError] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [categoryLabel, setCategoryLable] = useState([]);
  const [addCategoryRequest, setAddCategoryRequest] = useState<AddCategoryProps>({
    name: '',
    organizationId: '',
    categoryLabelId: '',
    lable: '',
  });
  const { name, categoryLabelId } = addCategoryRequest;
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(20);
  const [totalRowCount, setTotalRowCount] = useState<number>(0);
  const [requestState, setRequestState] = useState<RequestProps>({
    page: page,
    pageSize: limit,
    searchText: '',
    organizationFilter: [],
    LabelFilter: [],
    IsActiveFilter: true,
    sortBy: '',
    sortOrder: SortOrderType.ASC,
  });
  const categoryStatus = [
    { name: 'Active', value: true },
    { name: 'Inactive', value: false },
  ];

  const categoryLableFilter = [
    {
      Heading: 'Category Label',
      data: categoryLabel,
    },
  ];

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setAddCategoryRequest({
      ...addCategoryRequest,
      [event.target.name]: event.target.value,
    });

    if (event.target.name === 'name') {
      if (event.target.value !== '') {
        setFormError({ ...formError, [event.target.name]: undefined });
      } else {
        setFormError({
          ...formError,
          name: `Category is required`,
        });
      }
    }
    if (event.target.name === 'categoryLabelId') {
      if (event.target.value !== '') {
        setFormError({ ...formError, [event.target.name]: undefined });
      } else {
        setFormError({
          ...formError,
          categoryLabelId: `Category label is required`,
        });
      }
    }
  };

  useEffect(() => {
    const breadcrumb = [{ path: '/categories', name: 'Categories' }];
    dispatch(update_breadcrumb(breadcrumb));
    getAllCatogories(requestState);
    getCategoryLable();
  }, []);

  const getAllCatogories = (obj: RequestProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    instance
      .get(`/categories?${queryString}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: CategoryResponceProps) => {
    setCategory(data?.results as ResultProps[]);
    setTotalRowCount(data.totalCount);
    dispatch(updateIsLoading(false));
  };

  const onSubmit = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const validation = () => {
    const error: any = {};
    if (!name) {
      error.name = errorMessage.emptyCategory;
    } else if (name.length < 2 || name.length > 160) {
      error.name = errorMessage.categoryLength;
    }
    if (!categoryLabelId) {
      error.categoryLabelId = errorMessage.emptyCategoryLabel;
    }
    return error;
  };

  const onCancel = () => {
    setIsFormOpen(false);
    setIsSubmit(false);
    setFormError({});
    setAddCategoryRequest({
      ...addCategoryRequest,
      name: '',
      categoryLabelId: '',
    });
  };

  const viewRecord = (row: ResultProps) => {
    navigate(`/CategoryDetails/${row.id}`);
  };

  const searchHandler = () => {
    getAllCatogories({
      ...requestState,
      searchText: requestState.searchText,
      pageSize: limit,
      LabelFilter: [],
      page: 1,
    });
    setPage(1);
  };

  const onSearchHanlder = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setRequestState({ ...requestState, searchText: e.target.value });
  };

  const onClearSearch = () => {
    setRequestState({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
    getAllCatogories({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
  };
  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchHandler();
    }
  };
  const filterHandler = (arg: FitleObject[]) => {
    getAllCatogories({
      ...requestState,
      sortOrder: requestState.sortOrder,
      sortBy: requestState.sortBy,
      page: 1,
      pageSize: limit,
      LabelFilter: arg[0]?.selectedMenu,
      IsActiveFilter: requestState.IsActiveFilter,
    });
    setRequestState({
      ...requestState,
      LabelFilter: arg[0]?.selectedMenu,
    });
    setPage(1);
  };
  const statusFilterHandler = (row: any) => {
    getAllCatogories({
      ...requestState,
      sortOrder: requestState.sortOrder,
      sortBy: requestState.sortBy,
      page: 1,
      pageSize: limit,
      LabelFilter: requestState.LabelFilter,
      IsActiveFilter: row.value,
    });
    setRequestState({
      ...requestState,
      IsActiveFilter: row.value,
    });
    setPage(1);
  };

  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getAllCatogories({
        ...requestState,
        page: page,
        pageSize: limit,
        sortOrder: requestState.sortOrder,
        sortBy: requestState.sortBy,
      });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getAllCatogories({
          ...requestState,
          page: page + 1,
          pageSize: limit,
          organizationFilter: requestState.organizationFilter,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getAllCatogories({
          ...requestState,
          page: page - 1,
          pageSize: limit,
          sortOrder: requestState.sortOrder,
          sortBy: requestState.sortBy,
          organizationFilter: requestState.organizationFilter,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getAllCatogories({
          ...requestState,
          page: 1,
          pageSize: limit,
          sortOrder: requestState.sortOrder,
          sortBy: requestState.sortBy,
          organizationFilter: requestState.organizationFilter,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getAllCatogories({
          ...requestState,
          page: totalPages(totalRowCount, limit),
          pageSize: limit,
          sortOrder: requestState.sortOrder,
          sortBy: requestState.sortBy,
          organizationFilter: requestState.organizationFilter,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getAllCatogories({
        ...requestState,
        page: 1,
        pageSize: item,
        sortOrder: requestState.sortOrder,
        sortBy: requestState.sortBy,
        organizationFilter: requestState.organizationFilter,
      });
      setLimit(item);
      setPage(1);
    },
  };

  const sortRecord = (fieldName: string, sortOrder: string) => {
    getAllCatogories({
      ...requestState,
      sortOrder: sorting(sortOrder),
      sortBy: fieldName,
      page: page,
      pageSize: limit,
    });
    setRequestState({
      ...requestState,
      sortBy: fieldName,
      sortOrder: sorting(sortOrder),
    });
  };

  const sorting = (sortOrder: string) => {
    let temp = '';
    if (sortOrder == SortOrderType.DESC) {
      temp = SortOrderType.ASC;
    } else {
      temp = SortOrderType.DESC;
    }
    setRequestState({ ...requestState, sortOrder: temp });
    return temp;
  };

  //Add Category
  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      addCategory();
    }
  }, [formError]);

  const addCategory = () => {
    const obj = {
      name: name,
      organizationId: userInfo.organizationId,
      categoryLabelId: categoryLabelId,
    };
    instance
      .post(`/categories`, obj)
      .then((response) => {
        if (response.status === 201) {
          const obj = {
            isOpen: true,
            message: successMessage.CATEGORY_ADD,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          navigate(`/CategoryDetails/${response.data.id}`);
          setIsFormOpen(false);
          setAddCategoryRequest({
            ...addCategoryRequest,
            name: '',
            categoryLabelId: '',
            lable: '',
          });
          getAllCatogories({
            ...requestState,
            page: page,
            pageSize: limit,
            sortBy: '',
          });
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const getCategoryLable = () => {
    instance
      .get(`/category-labels?organizationId=${userInfo.organizationId}`)
      .then((response) => {
        if (response.status === 200) {
          setCategoryLable(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="px-2">
      <PageHeading label="Categories Management" />
      <div className="bg-white p-2 rounded-sm">
        <div className="xl:flex items-center justify-between mb-2">
          <div className="mb-3 xl:mb-0">
            <SearchInput
              value={requestState.searchText}
              onChange={onSearchHanlder}
              onSearch={searchHandler}
              onClear={() => onClearSearch()}
              handleEnterKeyPress={handleEnterKeyPress}
            />
          </div>

          <div className="flex items-center space-x-2">
            <Button
              label="Labels"
              type="button"
              buttonType="primary"
              onClick={() => navigate(`/categoryLabel`)}
            />

            {userInfo.role !== Role.User && (
              <div>
                <Button
                  label="Add"
                  type="button"
                  buttonType="primary"
                  icon={<i className="fa-solid fa-plus"></i>}
                  onClick={() => setIsFormOpen(!isFormOpen)}
                />
              </div>
            )}
          </div>
        </div>
        <div className="xl:flex items-center justify-between mb-2">
          <div className="mb-3 xl:mb-0">
            {' '}
            <MultipleFilter
              filterHandler={filterHandler}
              rootFilter={categoryLableFilter}
            />
          </div>

          <div className="mb-3 xl:mb-0">
            <Filter
              filterHandler={statusFilterHandler}
              rootFilter={categoryStatus}
              label={'Active'}
              heading="Select status"
            />
          </div>
        </div>
        <InputForm
          title={'Add New Category'}
          isFormOpen={isFormOpen}
          onSubmit={onSubmit}
          onCancel={onCancel}
        >
          <div className="lg:flex items-center justify-between">
            <Input
              name={'name'}
              type={'text'}
              label={'Category'}
              value={name}
              placeholder={`Enter Category`}
              onChange={(
                event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
              ) => {
                handleChange(event);
              }}
              error={formError?.name}
            />
            <Dropdown
              name={'categoryLabelId'}
              label={'Category Label'}
              value={categoryLabelId}
              onChange={(
                event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
              ) => {
                handleChange(event);
              }}
              error={formError?.categoryLabelId}
              initialOption={{
                name: 'Select Label',
                id: '',
              }}
              options={categoryLabel}
            />
          </div>
        </InputForm>

        <div className="mt-1">
          <MuiTable
            columns={columns}
            rows={category}
            page={page}
            limit={limit}
            paginateHandler={paginateHandler}
            totalRowCount={totalRowCount}
            onSortHandler={sortRecord}
            sortOrder={requestState.sortOrder}
            checkBoxShow={false}
            checkBoxValue={'id'}
            onViewHandler={viewRecord}
            showView={true}
            sortArray={['name', 'keywordCount']}
          />
        </div>
      </div>
    </div>
  );
};

export default Categories;
